import React from "react";
import { func, bool, string } from "prop-types";
import { twMerge } from "tailwind-merge";

import ArrowDownIcon from "../../shared/Icons/ArrowDown";
import Icon from "@components/shared/Icons/Icon";
import Typography from "../../shared/Typography";

const ClosedPackage = ({
  onClick,
  title,
  isSelected,
  backgroundUrl,
  singleItem,
}) => {
  return (
    <button
      data-id={`closed-package-${title}`}
      className={twMerge(
        "flex shrink-0 grow-0 basis-auto h-30 p-4 rounded-md uppercase whitespace-normal relative cursor-pointer",
        "bg-cover bg-no-repeat bg-right overflow-hidden",
        "transitions duration-150 active:scale-95",
        isSelected && "border-4 border-primaryOrange",
        singleItem ? "w-full h-39" : "w-30"
      )}
      onClick={onClick}
      style={{ backgroundImage: backgroundUrl }}
    >
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/30 to-black/0 z-0" />
      <Typography
        className="text-white font-semibold relative z-1"
        data-id={`closed-package-${title}`}
      >
        {title}
      </Typography>
      <Icon
        className={twMerge(
          "grid place-items-center size-10 p-2 rounded-tl-md",
          "absolute right-0 bottom-0 shadow-sm shadow-primaryOrange/10",
          isSelected
            ? "bg-primaryOrange text-white"
            : "bg-white text-primaryOrange"
        )}
        icon={<ArrowDownIcon />}
      />
    </button>
  );
};

ClosedPackage.propTypes = {
  onClick: func.isRequired,
  title: string.isRequired,
  isSelected: bool.isRequired,
  backgroundUrl: string.isRequired,
  singleItem: bool,
};

export default ClosedPackage;
